module.exports = __webpack_public_path__ + "static/media/target.08d1251e.png";